<template>
  <div>
    <img
      v-if="displayMode === 'lightMode'" src="./img/emworkshop.png" alt="EMBO Workshops"
      class="emworkshop" />
    <img v-else src="./img/emworkshop-darkMode.png" alt="EMBO Workshops" class="emworkshop" />
    <img v-if="displayMode === 'lightMode'" src="./img/embo.png" alt="EMBO" class="embo" />
    <img v-else src="./img/embo-darkMode.png" alt="EMBO" class="embo" />
    <img v-if="displayMode === 'lightMode'" src="./img/embl.png" alt="EMBL" />
    <img v-else src="./img/embl-darkMode.png" alt="EMBL" />
    <img v-if="displayMode === 'lightMode'" src="./img/embopress.png" alt="EMBO Press" class="embopress" />
    <img v-else src="./img/embopress-darkMode.png" alt="EMBO Press" class="embopress" />
    <img v-if="displayMode === 'lightMode'" src="./img/Autodesk.png" alt="Autodesk" title="Autodesk" class="autodesk" />
    <img v-else src="./img/Autodesk-darkMode.png" alt="Autodesk" title="Autodesk" class="autodesk" />
    <img
      v-if="displayMode === 'lightMode'" src="./img/HITS.png" class="hits"
      alt="Heidelberg Institute for Theoretical Studies"
      title="Heidelberg Institute for Theoretical Studies" />
    <img
      v-else src="./img/HITS-darkMode.png" class="hits"
      alt="Heidelberg Institute for Theoretical Studies"
      title="Heidelberg Institute for Theoretical Studies" />
    <img v-if="displayMode === 'lightMode'" src="./img/KWS.svg" alt="KWS" />
    <img v-else src="./img/KWS-darkMode.svg" alt="KWS" />
    <img v-if="displayMode === 'lightMode'" src="./img/IWR.svg" alt="Interdisciplinary Center for Scientific Computing" class="iwr" />
    <img v-else src="./img/IWR-darkMode.svg" alt="Interdisciplinary Center for Scientific Computing" class="iwr" />
    <a href="https://nymus3d.nl/" alt="DEMCON nymus3D" title="DEMCON nymus3D">
      <img v-if="displayMode === 'lightMode'" src="./img/Nymus3D.png" alt="DEMCON nymus3D" class="nymus3d" />
      <img v-else src="./img/Nymus3D-darkMode.png" alt="DEMCON nymus3D" class="nymus3d" />
    </a>
  </div>
  <p>
    If you would like to promote your organization to VIZBI participants, download the brochure with
    available
    <a href="/2019/Sponsors/img/Sponsorship_Brochure_VIZBI_2019.pdf" target="_blank">sponsorship options</a>.
    For more information about the opportunities available and who to contact, scroll to the
    <a href="#why">bottom of this page</a>.
  </p>
  <h4>Media Partners</h4>
  <ul>
    <li>
      <a href="https://www.journals.elsevier.com/computational-and-structural-biotechnology-journal">
        Computational and Structural Biotechnology Journal, an Elsevier journal</a>
    </li>
    <li><a href="http://embor.embopress.org/">EMBO Reports, an EMBO Press journal</a></li>
    <li><a href="http://rsob.royalsocietypublishing.org">Open Biology, a Royal Society journal</a></li>
    <li><a href="https://peerj.com/">PeerJ</a></li>
  </ul>
  <p>
    If you are interested in becoming a media partner, please visit our
    <a href="http://www.embl.de/training/events/sponsorship/mediapartnerships/">media partnerships page</a>.
  </p>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4 id="why">Why Sponsor VIZBI ?</h4>
  <p>
    VIZBI is an international conference series on Visualizing Biological Data that alternates
    between the European Molecular Biology Laboratory in Heidelberg, Germany, and the Broad
    Institute of MIT and Harvard in Cambridge MA, USA, with support from the NIH and EMBO. It also
    took place at the University of Sydney, Australia, with support from The Garvan Institute, UNSW,
    CSIRO's Data 61 and The Potter Foundation.
  </p>
  <p>
    VIZBI 2019 offers opportunities to promote organisations engaged with either data visualisation
    or the life sciences. Your organisation would gain exposure in a community that includes some of
    the most knowledgeable researchers and professionals working in biological data visualisation
    today. We expect at least 130 scientists, software developers, medical professionals,
    illustrators and designers from around the world to be attending VIZBI 2019. Our 21 invited
    speakers will review the state-of-the-art approaches and challenges in visualizing data from all
    of biology. As sponsor, your brand would be advertised alongside these talks, when the videos
    and posters from VIZBI 2019 are published on the main VIZBI site, which is accessed by over
    3,000 life scientists each month.
  </p>
  <h4>Becoming a Sponsor</h4>
  <p>
    The
    <a href="/2019/Sponsors/img/Sponsorship_Brochure_VIZBI_2019.pdf" target="_blank">
      VIZBI 2019 Sponsorship Brochure</a>
    offers a variety of event sponsoring possibilities, with the flexibility to select a set
    sponsorship package or to combine individual sponsorship options to suit your event budget.
    Discounts are available for companies sponsoring multiple events at EMBL Heidelberg.
    <a href="http://www.embl.de/training/events/index.php?p_eventType=CON&amp;p_outstation=HD&amp;p_timeRange=FUTURE&amp;submit=Show+Events">
      View other conferences</a>, or contact
    <a href="mailto:sponsorship@embl.de">sponsorship@embl.de</a> for further information.
  </p>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
div {
  column-gap: calc(1.9rem * 2);
}
div img {
  height: 3.3rem;
  width: auto;
}
img.emworkshop { height: calc(3.3rem * 0.85); }
img.embo       { height: calc(3.3rem * 0.83); }
img.embopress  { height: calc(3.3rem * 0.80); }
img.autodesk   { height: calc(3.3rem * 0.56); }
img.hits       { height: calc(3.3rem * 1.38); }
img.iwr        { height: calc(3.3rem * 2.38); }
img.nymus3d    { height: calc(3.3rem * 0.70); }
</style>
